import { getRequest } from 'config/Axios/baseConfig';
import { CleanByRoomDataInterface } from 'screens/CalculationsScreen/components/CleanByRoomTable/cleanByRoomTaleTypes';

export const cleanByRoomService = {
  getCleanByRoomData: async (date: string): Promise<CleanByRoomDataInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<CleanByRoomDataInterface>(
          `pps/calculations/clean-by-rooms/${date}`
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
